import React, { useState, useEffect } from 'react';
import NotificationCenter from './NotificationCenter';
import { MittelBoostLockup } from './BrandMark';

const NAV_BUTTONS = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>,
  },
  {
    id: 'termin',
    label: 'Termine diese Woche',
    icon: <><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
  },
  {
    id: 'pipeline',
    label: 'Dealpipeline',
    icon: <><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></>,
  },
];

function ThemeToggle({ theme, setTheme }) {
  const dark = theme === 'dark';
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 0,
        background: 'var(--bg3)',
        border: '1.5px solid var(--border)',
        borderRadius: 999, padding: '4px 10px',
        userSelect: 'none', cursor: 'default',
        height: 36,
      }}
    >
      {/* Light label */}
      <div
        onClick={() => setTheme('light')}
        style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '0 6px', cursor: 'pointer', opacity: dark ? 0.4 : 1, transition: 'opacity .2s' }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={dark ? 'var(--text3)' : '#d97706'} strokeWidth="2" strokeLinecap="round">
          <circle cx="12" cy="12" r="5"/>
          <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
          <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
        </svg>
        <span style={{ fontSize: 13, fontWeight: 500, color: dark ? 'var(--text3)' : 'var(--text)', transition: 'color .2s', whiteSpace: 'nowrap' }}>Light</span>
      </div>

      {/* Sliding pill */}
      <div
        onClick={() => setTheme(dark ? 'light' : 'dark')}
        style={{
          width: 40, height: 22, borderRadius: 999,
          background: dark ? '#159c5f' : '#d1d5db',
          position: 'relative', cursor: 'pointer',
          transition: 'background .25s', flexShrink: 0, margin: '0 4px',
        }}
      >
        <div style={{
          position: 'absolute', top: 3,
          left: dark ? 20 : 3,
          width: 16, height: 16, borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
          transition: 'left .22s cubic-bezier(0.4,0,0.2,1)',
        }} />
      </div>

      {/* Dark label */}
      <div
        onClick={() => setTheme('dark')}
        style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '0 6px', cursor: 'pointer', opacity: dark ? 1 : 0.4, transition: 'opacity .2s' }}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill={dark ? '#93a89a' : 'none'} stroke={dark ? '#93a89a' : 'var(--text3)'} strokeWidth="2" strokeLinecap="round">
          <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
        </svg>
        <span style={{ fontSize: 13, fontWeight: 500, color: dark ? 'var(--text)' : 'var(--text3)', transition: 'color .2s', whiteSpace: 'nowrap' }}>Dark</span>
      </div>
    </div>
  );
}

function useBranding(theme) {
  const read = () => {
    try {
      const b = JSON.parse(localStorage.getItem('crm_branding') || 'null');
      return {
        logo: theme === 'dark' ? (b?.logoDark || b?.logoLight || '') : (b?.logoLight || ''),
        companyName: b?.companyName || '',
        appName: b?.appName || '',
      };
    } catch { return { logo: '', companyName: '', appName: '' }; }
  };
  const [data, setData] = useState(read);
  useEffect(() => {
    // Only update when storage actually changes — no polling needed
    function sync() {
      const next = read();
      setData(prev =>
        prev.logo === next.logo && prev.companyName === next.companyName && prev.appName === next.appName
          ? prev
          : next
      );
    }
    window.addEventListener('storage', sync);
    window.addEventListener('crm-branding-changed', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('crm-branding-changed', sync);
    };
  }, [theme]); // eslint-disable-line
  return data;
}

export default function TopNav({ activeSection, setActiveSection, search, setSearch, theme, setTheme, onOpenSettings, searchRef, notifications = [], onMarkNotifRead, onMarkAllNotifsRead, onDismissNotif, onNavigateNotif, leads = [], tasks = [] }) {
  const { logo, companyName, appName } = useBranding(theme);
  const displayName = appName || (companyName ? `${companyName} CRM` : '');

  return (
    <header className="gl-topnav" style={{
      height: 60,
      display: 'flex',
      alignItems: 'center',
      padding: '0 22px',
      gap: 16,
      flexShrink: 0,
      zIndex: 30,
      position: 'relative',
    }}>
      {/* Logo / brand — Default: MittelBoost-Lockup */}
      {logo ? (
        <img src={logo} alt={companyName || 'Logo'} style={{ height: 28, objectFit: 'contain', flexShrink: 0, maxWidth: 140 }} />
      ) : displayName ? (
        <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--accent)', letterSpacing: '-0.025em', flexShrink: 0, whiteSpace: 'nowrap' }}>{displayName}</span>
      ) : (
        <MittelBoostLockup size={24} variant={theme === 'dark' ? 'dark' : 'light'} style={{ flexShrink: 0 }} />
      )}

      {/* Search — center */}
      <div role="search" style={{ flex: 1, maxWidth: 440, position: 'relative' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          aria-hidden="true"
          style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--text3)', pointerEvents: 'none' }}>
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" strokeLinecap="round"/>
        </svg>
        <input
          type="text"
          ref={searchRef}
          placeholder="Suchen… (K)"
          aria-label="Kontakte und Leads suchen"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="gl-search"
          style={{
            width: '100%', height: 36,
            borderRadius: 'var(--radius)',
            color: 'var(--text)', fontSize: 13,
            padding: '0 14px 0 36px',
            outline: 'none',
          }}
        />
      </div>

      <div style={{ flex: 1 }} />

      {/* Nav buttons */}
      <div style={{ display: 'flex', gap: 5 }}>
        {NAV_BUTTONS.map(btn => {
          const active = activeSection === btn.id;
          return (
            <button
              key={btn.id}
              onClick={() => setActiveSection(btn.id)}
              className={active ? 'topnav-btn topnav-btn--active' : 'topnav-btn'}
              style={{
                fontSize: 13, fontWeight: active ? 600 : 400,
                display: 'flex', alignItems: 'center', gap: 6,
                cursor: 'pointer', whiteSpace: 'nowrap',
              }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">{btn.icon}</svg>
              {btn.label}
            </button>
          );
        })}
      </div>

      <div style={{ width: 1, height: 24, background: 'var(--border)', flexShrink: 0 }} />

      <ThemeToggle theme={theme} setTheme={setTheme} />

      <NotificationCenter
        notifications={notifications}
        onMarkRead={onMarkNotifRead}
        onMarkAllRead={onMarkAllNotifsRead}
        onDismiss={onDismissNotif}
        onNavigate={onNavigateNotif}
        leads={leads}
        tasks={tasks}
      />

      <button onClick={onOpenSettings} title="Einstellungen" aria-label="Einstellungen"
        style={{ width: 36, height: 36, borderRadius: 9, background: 'var(--bg3)', border: '1.5px solid var(--border)', color: 'var(--text2)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all .12s' }}
        onMouseEnter={e => { e.currentTarget.style.background = 'var(--accent-bg)'; e.currentTarget.style.color = 'var(--accent)'; e.currentTarget.style.borderColor = 'var(--accent-border)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg3)'; e.currentTarget.style.color = 'var(--text2)'; e.currentTarget.style.borderColor = 'var(--border)'; }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
          <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
        </svg>
      </button>
    </header>
  );
}
